<template>
  <div class="organization-container custom-success-input">
    <div class="organization-body">
      <div class="content" v-loading="loading">
        <div class="left">
          <div class="title">
            <h3>组织机构</h3>
          </div>
          <div class="custom-tree tree">
            <el-tree
               ref="tree"
              :data="nodeList"
              :props="defaultProps"
              node-key="id"
              @node-click="nodeClick"
              @node-drop="handleDrop"
              :allow-drop="allowDrop"
              :expand-on-click-node="false"
              :default-expanded-keys="defaultOpenMenu"
              draggable
              @node-expand="expandNode"
              @node-collapse="collapseNode"
            >
              <span
                class="custom-tree-node"
                slot-scope="{ node, data }"
                @mouseover="showIcon(data)"
                @mouseout="hiddenIcon(data)"
              >
                <span :title="node.label">{{ node.label }}</span>
                <span class="show-icon" :ref="data.id">
                  <el-button
                    class="el-icon-circle-plus-outline"
                    type="text"
                    @click.stop.prevent="appendNode(node, data)"
                  ></el-button>
                  <el-button
                    class="el-icon-circle-close"
                    v-if="data.id !== nodeList[0].id"
                    type="text"
                    @click.stop.prevent="removeNode(node, data)"
                  ></el-button>
                </span>
              </span>
            </el-tree>
          </div>
        </div>
        <div class="right">
          <el-tabs v-model="activeNum" type="card">
            <el-tab-pane label="部门信息" name="departmentInfo">
              <div class="form">
                <el-form
                  :label-position="labelPosition"
                  :inline="true"
                  ref="peopleInfoForm"
                  label-width="60px"
                  :model="formData.depFormData"
                  :rules="formRules.depFormDataRules"
                  @submit.native.prevent
                >
                  <div class="item">
                    <el-form-item label="名称" prop="name">
                      <el-input v-model="formData.depFormData.name"></el-input>
                    </el-form-item>
                    <el-form-item class="right-item" label="传真">
                      <el-input v-model="formData.depFormData.fax"></el-input>
                    </el-form-item>
                  </div>
                  <div class="item">
                    <el-form-item label="电话">
                      <el-input v-model="formData.depFormData.tel"></el-input>
                    </el-form-item>
                    <el-form-item class="right-item" label="邮编">
                      <el-input v-model="formData.depFormData.zipCode"></el-input>
                    </el-form-item>
                  </div>
                  <div class="item">
                    <el-form-item label="联系人">
                      <el-input v-model="formData.depFormData.contacts"></el-input>
                    </el-form-item>
                    <el-form-item class="right-item" label="网址">
                      <el-input v-model="formData.depFormData.url"></el-input>
                    </el-form-item>
                  </div>
                  <div class="item">
                    <el-form-item label="负责人">
                      <el-input v-model="formData.depFormData.principalName" :disabled="true">
                        <el-button slot="append" type="primary" @click="dialogTableVisible=true">选择</el-button>
                      </el-input>
                    </el-form-item>
                    <el-form-item class="right-item" label="上级部门">
                      <el-select  v-model="formData.depFormData.parentId" filterable>
                       <el-option v-for="dep in depList"  :key="dep.id"  :label="dep.name" :value="dep.id"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <el-form-item label="地址">
                    <el-input type="textarea" v-model="formData.depFormData.address" resize="none"></el-input>
                  </el-form-item>
                  <el-form-item label="描述">
                    <el-input type="textarea" v-model="formData.depFormData.describeText" resize="none"></el-input>
                  </el-form-item>
                </el-form>
              </div>
              <div class="operation">
                <el-button type="primary" @click="saveDepInfo">保存</el-button>
              </div>
            </el-tab-pane>
            <el-tab-pane label="岗位列表" name="postList">
              <div class="post-list">
                <div class="post-form">
                  <el-form
                    :inline="true"
                    ref="searchForm"
                    :model="formData.postFormData"
                    label-width="60px"
                    :label-position="labelPosition"
                    @submit.native.prevent
                  >
                    <el-form-item label="岗位名称">
                      <el-input v-model="formData.postFormData.postName" placeholder="请输入岗位名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="岗位分类">
                      <el-select v-model="formData.postFormData.categoryId" placeholder="请选择岗位分类" clearable>
                        <el-option
                          v-for="item in selectList.postNameList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item class="post-btn">
                      <el-button @click="searchPost">查询</el-button>
                    </el-form-item>
                    <el-form-item class="post-btn">
                      <el-button @click="reset">重置</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="primary" @click="newCreate">新建</el-button>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="post-table">
                  <el-table height="100%" :data="postData" ref="postTable">
                    <el-table-column type="index" width="50" label="序列"></el-table-column>
                    <el-table-column
                      v-for="column in columnData"
                      :prop="column.prop"
                      :key="column.prop"
                      :label="column.label"
                      :resizable="column.resizable"
                      :show-overflow-tooltip="true"
                      :align="column.align"
                      min-width="100"
                      :formatter="formatTime"
                      v-cloak
                    ></el-table-column>
                    <el-table-column width="100" align="center" label="操作">
                      <template slot-scope="scope">
                        <el-button type="text" @click="deleteColumn(scope.row)">删除</el-button>
                        <el-button type="text" @click="modifyColunm(scope.row)">修改</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <div class="paging">
                  <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="parseInt(pagingParams.totalNum)"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    :page-size="pagingParams.size"
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page="pagingParams.index"
                  ></el-pagination>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div class="new-create-dialog">
          <el-dialog
            title="新增岗位"
            :visible.sync="dialogParams.newCreateDialogVisible"
            :close-on-click-modal="false"
            top="10vh"
            :width="dialogParams.dialogWidth"
            :before-close="beforeCloseAdd"
          >
            <div class="new-create-body">
              <el-form
                :inline="true"
                :model="formData.newCreateFormData"
                :rules="formRules.newCreateFormRules"
                label-width="70px"
                :label-position="labelPosition"
                ref="newCreateForm"
              >
                <el-form-item label="上级岗位">
                  <el-select placeholder="请选择上级岗位" v-model="formData.newCreateFormData.superior" clearable>
                    <el-option
                      v-for="item in selectList.upPostList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="岗位分类" prop="categoryId">
                  <el-select placeholder="请选择岗位分类" v-model="formData.newCreateFormData.categoryId">
                    <el-option
                      v-for="item in selectList.postNameList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="岗位名称" prop="name">
                  <el-input placeholder="请输入岗位名称" v-model="formData.newCreateFormData.name"></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
              <div class="dialog-operation">
                <el-button @click="cancelAdd">取消</el-button>
                <el-button type="primary" @click="addPost">保存</el-button>
              </div>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
    <el-dialog class="people-detail-dialog organization-dialog" title="请选择" v-if="dialogTableVisible" :visible.sync="dialogTableVisible" center append-to-body :close-on-click-modal="false">
      <account-list ref="account" :selected="true" :deptId="depSelectId"></account-list>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSelectMember">确定</el-button>
        <el-button @click="dialogTableVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { UUID } from '@/plugins/common'
import _ from 'lodash'
import AccountList from './account-list.vue'
const columnData = [
  {
    prop: 'id',
    label: '岗位ID',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'name',
    label: '岗位名称',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'superiorName',
    label: '上级岗位',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'categoryName',
    label: '岗位分类',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'departmentName',
    label: '所属部门',
    resizable: false,
    align: 'center'
  },
  {
    prop: 'createTime',
    label: '创建时间',
    resizable: false,
    align: 'center'
  }
]
export default {
  name: 'organization',
  data () {
    let isEmpty = (rule, value, callback) => {
      if (value.replace(/(^\s*)|(\s*$)/g, '') === '') {
        return callback(new Error('名称不能为空'))
      } else {
        return callback()
      }
    }
    let maxLength = (rule, value, callback) => {
      if (value.length > 20) {
        return callback(new Error('文本框限制只可输入20个字符'))
      } else {
        return callback()
      }
    }
    return {
      loading: false,
      defaultOpenMenu: [],
      dialogTableVisible: false,
      nodeList: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 默认选中部门信息
      activeNum: 'departmentInfo',
      labelPosition: 'left',
      selectMemberId: '',
      selectList: {
        postNameList: [],
        upPostList: []
      },
      postData: [],
      columnData,
      pagingParams: {
        totalNum: 0,
        index: 1,
        size: 20
      },
      // 所有的表单数据
      formData: {
      // 部门信息
        depFormData: {
          name: '',
          parentDepartmentName: ''
        },
        // 岗位列表
        postFormData: {
          postName: '',
          categoryId: ''
        },
        // 新增岗位
        newCreateFormData: {
          name: '',
          superior: '',
          categoryId: '',
          id: ''
        }
      },
      // 所有的校验规则
      formRules: {
        depFormDataRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }, {validator: isEmpty, trigger: 'blur'}]
        },
        newCreateFormRules: {
          name: [{ required: true, message: '请输入岗位名称', trigger: 'blur' }, {validator: maxLength, trigger: 'blur'}],
          categoryId: [{ required: true, message: '请选择岗位分类' }]
        }
      },
      dialogParams: {
        newCreateDialogVisible: false,
        treeDialogVisible: false,
        dialogWidth: '45%'
      },
      // 直属上级ztree
      userTreeList: [],
      selectUser: {},
      // 右边选中的id
      depSelectId: '',
      // 保存一份新建的时候的自定义id
      isNewCreateId: '',
      newCreateParent: {},
      selectNodeParentId: '',
      selectNodeId: '',
      depList: []
    }
  },
  components: {
    AccountList
  },

  methods: {
    // 展开节点时把id放入默认展开的数组中
    expandNode (node) {
      this.defaultOpenMenu.push(node.id)
    },
    // 关闭节点将删除这个节点id
    collapseNode (node) {
      let closedNodeIndex = this.defaultOpenMenu.findIndex(n => n === node.id)
      this.defaultOpenMenu.splice(closedNodeIndex, 1)
    },
    findComponent  (current, id) {
      if (current.id === id) {
        return current
      }
      for (const item of current.children) {
        let restlt = this.findComponent(item, id)
        if (restlt) {
          return restlt
        }
      }
    },
    handleDrop (draggingNode, dropNode, dropType) {
      this.loading = true
      let parentOrganization = null
      if (dropType === 'inner') {
        parentOrganization = this.findComponent({children: this.nodeList}, dropNode.data.id)
      } else {
        parentOrganization = this.findComponent({children: this.nodeList}, dropNode.data.parentId)
      }
      if (parentOrganization) {
        //  调用接口重新请求树的顺序
        let childrenOrganization = parentOrganization.children.map((m, index) => {
          return { id: m.id, index: index }
        })
        childrenOrganization.find(n => n.id === draggingNode.data.id).parentId = parentOrganization.id
        this.$axios.post(`/auth-api/organization/exchangeDeptSort`, childrenOrganization)
          .then(() => this.getLeftTreeList())
          .then(() => {
            this.$refs.tree.setCurrentKey(this.selectNodeId)
            this.loading = false
          })
          .catch(() => {
            this.loading = false
          })
      }
    },
    allowDrop (draggingNode, dropNode, type) {
      // 不允许拖到和一级节点同级
      if (dropNode.data.id === this.defaultOpenMenu[0]) {
        return type !== 'prev'
      } else {
        return true
      }
    },

    showIcon (data) {
      this.$refs[data.id].style.visibility = 'visible'
      // 代表是新增的,需要隐藏新增按钮
      if (data.id === this.isNewCreateId) {
        this.$refs[data.id].querySelector('.el-icon-circle-plus-outline').style.visibility = 'hidden'
      }
    },
    hiddenIcon (data) {
      this.$refs[data.id].style.visibility = 'hidden'
    },
    appendNode (node, data) {
      if (data.children.length === 0) {
        // 新增第一个部门需要存
        this.defaultOpenMenu.push(data.id)
      }
      // 点击添加的时候，应该删除未保存的
      if (this.isNewCreateId) {
        let index = this.newCreateParent.children.findIndex(d => d.id === this.isNewCreateId)
        if (index !== -1) {
          this.newCreateParent.children.splice(index, 1)
        }
      }
      this.activeNum = 'departmentInfo'
      let uuid = UUID.create()
      this.formData.depFormData.name = '新建部门'
      this.isNewCreateId = uuid
      this.$nextTick(() => {
        if (!(this.depList.find(item => item.id === data.id))) {
          this.depList.push({
            id: data.id,
            name: data.name
          })
        }
        let newChild = { id: uuid, flag: true, name: this.formData.depFormData.name, parentId: data.id, children: [] }
        if (!data.children) {
          this.$set(data, 'children', [])
        }
        data.children.push(newChild)
        node.expanded = true
        this.$nextTick(() => {
          this.newCreateParent = data
          this.$refs.tree && this.$refs.tree.setCurrentKey(uuid)
          for (let key in this.formData.depFormData) {
            if (this.formData.depFormData[key] && key !== 'name') {
              this.formData.depFormData[key] = ''
            }
          }
          this.activeNum = 'departmentInfo'
          this.$nextTick(() => {
            this.formData.depFormData.parentDepartmentName = data.name
            this.formData.depFormData.parentId = data.id
          })
        })
      })
    },
    removeNode (node, data) {
      // 代表删除没有新增的
      if (data.flag) {
        let parent = node.parent
        let children = parent.data.children || parent.data
        let index = children.findIndex(d => d.id === data.id)
        children.splice(index, 1)
        this.$refs.tree && this.$refs.tree.setCurrentKey(this.depSelectId)
        this.$nextTick(() => {
          this.getDetailsByDepId(this.depSelectId)
          this.getPostList(this.depSelectId)
        })
      } else {
        this.$confirm('是否确认删除？', '', {
          confirmButtonText: '是的，我确认删除',
          cancelButtonText: '容我重新思考一下',
          customClass: 'deleMessageBox-custom'
        }).then(() => {
          this.selectNodeId = node.parent ? node.parent.data.id : ''
          this.deleteDep(data.id)
          this.$nextTick(() => {
            this.$refs.tree && this.$refs.tree.setCurrentKey(node.parent.id)
            this.activeNum = 'departmentInfo'
          })
        }).catch(() => {})
      }
    },
    // 左侧树节点点击
    nodeClick (data, node) {
      this.selectNodeParentId = data.parentId
      this.selectNodeId = data.id
      if (data.flag !== true) {
        this.$refs[data.id].style.display = 'inline-block'
        this.depSelectId = data.id
        this.pagingParams.index = 1
        this.$nextTick(() => {
          this.getDetailsByDepId(data.id)
          this.getPostList(data.id)
          this.getParentDep(data.id)
        })
      } else {
        // 如果点了其他的需要先把formDta中其他值清空,否则提交保存时会有错误
        for (let key in this.formData.depFormData) {
          if (this.formData.depFormData[key]) {
            this.formData.depFormData[key] = ''
          }
        }
        this.formData.depFormData.name = data.name
        this.formData.depFormData.parentId = data.parentId
      }
    },
    saveSelectMember () {
      if (Object.keys(this.$refs.account.currentRow).length !== 0) {
        this.formData.depFormData.principal = this.$refs.account.currentRow.id
        this.formData.depFormData.principalName = this.$refs.account.currentRow.name
        this.dialogTableVisible = false
      } else {
        this.$message({
          message: '你没有选择任何数据, 请选择后操作.',
          center: true,
          duration: 1000,
          customClass: 'without-execute-dialog'
        })
      }
    },
    getPostList (id) {
      let params = {
        index: this.pagingParams.index,
        size: this.pagingParams.size
      }
      params.filters = {
        postName: this.formData.postFormData.postName,
        categoryId: this.formData.postFormData.categoryId,
        deptId: this.depSelectId,
        flag: '1'
      }
      this.$axios.get(`/auth-api/organization/getPosts`, {params}).then(res => {
        this.postData = res.data.items
        this.pagingParams.totalNum = res.data.total
      })
    },
    searchPost () {
      if (this.formData.postFormData.postName.replace(/(^\s*)|(\s*$)/g, '') !== '' || this.formData.postFormData.categoryId !== '') {
        this.pagingParams.index = 1
      }
      this.formData.postFormData.postName = this.formData.postFormData.postName.replace(/(^\s*)|(\s*$)/g, '')
      this.$nextTick(() => {
        this.getPostList(this.depSelectId)
      })
    },
    reset () {
      this.pagingParams.index = 1
      this.formData.postFormData.postName = ''
      this.formData.postFormData.categoryId = ''
      this.$nextTick(() => {
        this.getPostList(this.depSelectId)
      })
    },
    sizeChange (val) {
      this.pagingParams.index = 1
      this.pagingParams.size = val
      this.$nextTick(() => {
        this.getPostList(this.depSelectId)
      })
    },
    currentChange (val) {
      this.pagingParams.index = val
      this.$nextTick(() => {
        this.getPostList(this.depSelectId)
      })
    },
    newCreate () {
      this.getUpPostList()
    },
    // 获取左边树节点
    getLeftTreeList () {
      return new Promise((resolve, reject) => {
        this.$axios.get('/auth-api/organization/getTree').then(res => {
          this.nodeList = res.data || []
          this.$nextTick(() => {
            this.depSelectId = this.selectNodeId || this.nodeList[0].id
            this.$nextTick(() => {
              if (this.depSelectId) {
              // 选中节点
                this.$refs.tree && this.$refs.tree.setCurrentKey(this.depSelectId)

                // 获取部门信息
                this.getDetailsByDepId(this.depSelectId)
                // 获取岗位信息
                this.getPostList(this.depSelectId)
                // 获取下拉列表
                this.getPostCategories()
                resolve()
              }
            })
          })
        })
      })
    },
    getDetailsByDepId (id) {
      this.$axios.get(`/auth-api/organization/getDetails/${id}`).then(res => {
        this.formData.depFormData = res.data
      })
    },
    getParentDep (selectId) {
      this.$axios.get(`/auth-api/departments/parentDept/${selectId}`).then(res => {
        this.depList = res.data
      })
    },
    // 保存部门信息
    saveDepInfo () {
      this.$refs.peopleInfoForm.validate(validate => {
        if (validate) {
          this.formData.depFormData.state = 1
          this.$nextTick(() => {
            this.$axios.post('/auth-api/departments', this.formData.depFormData).then(res => {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.selectNodeId = res.data.id
              this.isNewCreateId = ''
              this.newCreateParent = {}
              this.getLeftTreeList()
            })
          })
        } else {
          return false
        }
      })
    },
    // 获取直属上级树节点
    getPrincipal () {
      this.$axios.get(`/auth-api/organization/getUserTree`).then(res => {
        this.userTreeList = res.data || []
      })
    },
    // 删除部门
    deleteDep (id) {
      this.$axios.delete(`/auth-api/departments/${id}`).then(res => {
        this.getLeftTreeList()
      })
    },
    clearDialogData (type) {
      this.selectUser = {}
      this.selectMemberId = ''
      this.formData.newCreateFormData = {
        name: '',
        superior: '',
        categoryId: '',
        id: ''
      }
      this.$nextTick(() => {
        this.dialogParams[type] = false
      })
    },
    // 删除岗位
    deleteColumn (row) {
      this.$confirm('是否确认删除？', '', {
        confirmButtonText: '是的，我确认删除',
        cancelButtonText: '容我重新思考一下',
        customClass: 'deleMessageBox-custom'
      }).then(() => {
        this.$axios.delete(`/auth-api/posts/${row.id}`).then(res => {
          this.getPostList(this.depSelectId)
        })
      }).catch(() => {})
    },
    // 修改岗位
    modifyColunm (row) {
      this.getUpPostList(row)
      this.$nextTick(() => {
        this.formData.newCreateFormData.name = row.name
        this.formData.newCreateFormData.superior = row.superior
        this.formData.newCreateFormData.categoryId = row.categoryId
        this.formData.newCreateFormData.id = row.id
      })
    },
    formatTime (row, column, cellValue) {
      if (column.property === 'createTime') {
        if (cellValue) {
          let datetime = new Date(cellValue)
          let y = datetime.getFullYear()
          let m = datetime.getMonth() + 1
          let d = datetime.getDate()
          return `${y}-${m < 10 ? ('0' + m) : m}-${d < 10 ? ('0' + d) : d}`
        }
        return ''
      }
      return cellValue
    },
    // 获取岗位分类
    getPostCategories () {
      this.$axios.get(`/auth-api/organization/getPostCategories`).then(res => {
        this.selectList.postNameList = res.data
      })
    },
    // 获取上级岗位分类
    getUpPostList (row) {
      let params = {
        filters: {
          postName: '',
          categoryId: '',
          deptId: this.depSelectId,
          flag: '0'
        }
      }
      this.$axios.get(`/auth-api/organization/getPosts`, {params}).then(res => {
        // 编辑的时候获取的上级岗位需要过滤自身
        let data = res.data.items || []
        if (row && data && data.length) {
          data = data.filter(d => d.id !== row.id)
        }
        this.selectList.upPostList = data
        this.$nextTick(() => {
          this.dialogParams.newCreateDialogVisible = true
        })
      })
    },
    // 保存新增岗位
    addPost () {
      let params = {...this.formData.newCreateFormData}
      params.departmentId = this.depSelectId
      params.state = '1'
      this.$refs.newCreateForm.validate(validate => {
        if (validate) {
          this.$nextTick(() => {
            this.$axios.post('/auth-api/posts', params).then(res => {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.$refs.newCreateForm.resetFields()
              this.clearDialogData('newCreateDialogVisible')
              this.getPostList(this.depSelectId)
            })
          })
          this.getLeftTreeList()
        } else {
          return false
        }
      })
    },
    // 取消保存
    cancelAdd () {
      this.$refs.newCreateForm.resetFields()
      this.clearDialogData('newCreateDialogVisible')
    },
    beforeCloseAdd (done) {
      this.$refs.newCreateForm.resetFields()
      this.$nextTick(() => {
        done()
      })
    }
  },
  mounted () {
    this.getLeftTreeList()
      .then(() => {
        this.getParentDep(this.nodeList[0].id)
        this.defaultOpenMenu.push(this.nodeList[0].id)
      })
    this.dialogParams.dialogWidth = document.body.clientWidth > 1500 ? '45%' : '65%'
    window.onresize = _.debounce(e => {
      this.dialogParams.dialogWidth = document.body.clientWidth > 1500 ? '45%' : '65%'
    }, 10)
  }
}
</script>

<style lang="scss">
  [v-cloak] {
    display: none;
  }
  .organization-container {
    height: 100%;

    div,
    span,
    p,
    label {
      font-size: 12px;
    }

    .organization-body {
      height: 100%;
      padding: 10px;
      padding-left: 0;
      padding-right: 0;

      .content {
        height: 100%;
        width: 100%;

        .left {
          background: #fff;
          box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
          border-radius: 4px 0;
          padding-top: 13px;
          width: 284px;
          height: 100%;
          float: left;
          overflow: auto;

          .show-icon {
            display: inline-block;
            visibility: hidden;
            vertical-align: top;
          }

          .title {
            position: relative;
            h3 {
              border-left: 2px solid var(--primary, #09131d);
              padding-left: 12px;
              font-size: 14px;
              font-weight: 500;
            }
          }

          .tree {
            display: inline-block;
            min-width: 100%;
            padding: 10px 0 0 20px;
            .is-focusable.is-drop-inner {
              .custom-tree-node {
                span:nth-child(1){
                background: var(--primary, #62A8F2);
                }
              }
            }
            .custom-tree-node {
              width: 100%;
              height: 25px;
              line-height: 25px;

              &:hover {
                color: var(--primary, #62A8F2);
              }
              span:first-of-type{
                display: inline-block;
                width: 120px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              }
            }
            .el-tree-node__label {
              font-size: 12px;
              color: #383838;
            }

            .el-icon-circle-close {
              color: #ccc;
              padding: 0;
            }

            .el-icon-circle-plus-outline {
              margin-left: 5px;
              padding: 0;
            }

            .el-icon-circle-close,
            .el-icon-circle-plus-outline {
              font-size: 14px;
            }

            .el-button+.el-button {
              margin-left: 5px;
            }
          }
        }

        .right {
          background: #fff;
          box-shadow: 0px 3px 9px 0px rgba(179, 196, 208, 0.2);
          border-radius: 4px 0;
          height: 100%;
          margin-left: 10px;
          padding: 10px 10px 0 0;
          overflow: hidden;;

          .el-tabs__content {
            overflow: auto;
          }

          .el-tabs,
          #pane-postList {
            height: 100%;
          }

          .el-tabs__content {
            height: calc(100% - 60px);
          }

          .el-tabs__header {
            border-bottom: 0px;

            #tab-departmentInfo,
            #tab-postList {
              font-size: 14px;
            }

            .is-active {
              border-bottom: 2px solid var(--primary, #62A8F2);
            }

            .el-tabs__nav {
              border: 0;
            }

            #tab-postList {
              border-left: 0;
              position: relative;

              &::before {
                content: "";
                display: block;
                position: absolute;
                width: 0;
                height: 20px;
                border: 0.5px solid var(--primary, #62A8F2);
                bottom: 19%;
                left: 0;
              }
            }
          }

          .form {
            width: 800px;
            padding: 20px 10px;
            margin: 0 auto;

            .item {
              .el-input {
                width: 238px;
              }

              .right-item {
                margin-left: 80px;
              }

              .el-input-group__append {
                background-color: var(--primary, #62A8F2);
                color: #fff;
                border-color: var(--primary, #62A8F2);
              }
            }

            .el-textarea {
              .el-textarea__inner {
                width: 630px;
                height: 82px;
              }
            }
          }

          .operation {
            text-align: center;
            padding: 20px 0 20px 0;
          }

          .post-list {
            padding: 10px;
            height: 100%;

            .post-form {
              .post-btn {
                margin-right: 15px;
                margin-left: 15px;
              }

              .el-form {
                .el-form-item:nth-child(4) {
                  margin-right: 30px;
                }
              }
            }

            .post-table {
              height: calc(100% - 90px);
            }
          }

          .paging {
            text-align: right;
            padding-top: 15px;
          }
        }

        @media screen and (max-width: 1400px) {
          .right {
            flex: 6;

            .form {
              padding: 20px 50px;
            }
          }

          .left {
            flex: 2;
          }
        }

        .new-create-dialog {
          .el-dialog__body {
            padding-bottom: 5px;
          }
        }
      }

      .is-error {
        .el-form-item__content {
          .el-input__inner {
            border-color: #f56c6c;
          }
        }
      }
    }

  }
  .organization-dialog {
    .el-dialog .el-dialog__body {
      height: 490px;
    }
  }
  @import "@/assets/scss/common.scss";
</style>



// WEBPACK FOOTER //
// src/components/system/users/organization.vue